import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, MenuItem, Switch, Tooltip, Typography } from '@material-ui/core';
import { AttachFile, Cancel, CheckCircle, Error, GetApp, History, HourglassEmpty, ThumbDown, WatchLater } from '@material-ui/icons';
import AddIcon from '@material-ui/icons/Add';
import {
  deveReenviarSolicitacao,
  podeCadastrarEventoExtraordinario,
  podeCancelarSolicitacaoEvento,
  podeSolicitarLiquidacao,
} from 'pages/instrumentos/gerenciar/eventoExtraordinarioRegras';
import RemoveIcon from '@material-ui/icons/Remove';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { DataGridPro, getGridDateOperators, getGridStringOperators, GridCellParams, GridFilterModel, GridRowId, GridSortModel, GridValueGetterParams } from '@mui/x-data-grid-pro';
import { eventoFinanceiroDescriptions, getInstrumentoFinanceiroLongDescription, pagamentoStatusDescriptions } from 'common/genericDescriptions';
import { useGenericStyles } from 'common/genericStyles';
import {
  EventoExtraordinarioTipo, EventosFinanceirosFilter, FuncaoParticipante,
  GrupoAcesso, InvestidorResumoQuantidade, PagamentoDocuments, PagamentoResponse,
  PagamentoSolicitarLiquidacaoRequest,
  PagamentoStatus,
  PagamentoTipo, Perfil, TipoLiquidacao
} from 'common/genericTypes';
import {
  parseLiquidacaoEmLoteExcel,
  buildLiquidacaoEmLoteRequest,
} from 'services/liquidacaoEmLoteService';
import {
  POSTConsultarLiquidacaoEmLote,
  GETModeloLiquidacaoEmLote,
  LiquidacaoEmLoteConsultaResponse,
  POSTDocumentosLiquidacao,
} from 'requests/instrumentos';
import { GenericDrawer } from 'components/genericDrawer';
import { GenericToast, GenericToastKind } from 'components/genericToast';
import MoreOptionsMenu from 'components/moreOptionsMenu';
import UploadDocs, { AcceptableFileTypes, Attachment as Files } from 'components/uploadDocs';
import { Attachment, Button, Dropdown, LgSpace, MdSpace, NumberField, RadioButton, SmSpace, TextField, XlSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { componentsPropsValues, localizedTextsMap, rowsPerPageOptionsValues } from 'utils/dataGrid/dataGridUtils';
import DataGridToolbar from 'utils/dataGrid/xlsxExportToolbar';
import { formatDate } from 'utils/date';
import { formatEightDecimalsCurrency } from 'utils/number';
import { ConfirmarLiquidacaoDrawer } from './confirmarLiquidacaoDrawer';
import { AnexarComprovanteDrawer } from './AnexarComprovanteDrawer';
import EventoExtraordinarioDrawer from './eventoExtraordinarioDrawer';
import { ValidarLiquidacaoDrawer } from './validarLiquidacaoDrawer';
import { RevisarPagamentoAgenteFiduciarioDrawer } from './revisarPagamentoAgenteFiduciarioDrawer';
import { SolicitarLiquidacaoBrutaEmissorDrawer } from './solicitarLiquidacaoBrutaEmissorDrawer';
import { SolicitarLiquidacaoBrutaAgenteFiduciarioDrawer } from './solicitarLiquidacaoBrutaAgenteFiduciarioDrawer';
import LegendaStatusEventos from './legendaStatusEventos';
import { HistoricoPUsModal } from './historicoPUsDrawer';
import LiquidacaoEmLote, { LiquidacaoEmLoteItem } from 'components/liquidacaoEmLote/liquidacaoEmLote';
import FeedbackLoteModal, { FeedbackLoteData } from 'components/feedbackLoteModal/feedbackLoteModal';
import { addAlert } from 'store/modules/snackBar';
import { validaEmail } from 'utils/validation';
import { errorMessages } from 'common/errorMessages.strings';
import { deveExibirAvisoConfirmacaoAgenteFiduciario, formatInstrumentoCurrency } from 'utils/instrumentoFinanceiroUtils';
import { addCpfCnpjMask } from 'utils/mask';
import { CpfCnpjMask } from 'components/masks';
import { stripCpfCnpjFormatting } from 'utils/validation';

enum TipoLancamento {
  Percentual = "PERCENTUAL",
  ValorPagamento = "VALOR_PAGAMENTO",
}

const tipoLancamentoOptions = [
  {
    description: 'Percentual',
    value: TipoLancamento.Percentual
  },
  {
    description: 'Valor de Pagamento',
    value: TipoLancamento.ValorPagamento
  },
]

const InvestidoresPrivadosDetail = ({ investidores }: { investidores?: Array<InvestidorResumoQuantidade> }) => {
  if (!investidores || investidores.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Typography variant="body1" color="textSecondary">
          Este instrumento não possui investidores privados registrados.
        </Typography>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <Typography variant="h6" gutterBottom>
        Investidores Privados ({investidores.length})
      </Typography>
      <Grid container spacing={2}>
        {investidores.map((investidor) => (
          <Grid item xs={12} sm={6} md={4} key={investidor.id}>
            <div style={{ padding: '16px', height: '100%' }}>
              <Typography gutterBottom>
                {investidor.razaoSocial}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                CPF/CNPJ: {addCpfCnpjMask(investidor.cpfCnpj)}
              </Typography>
              {investidor.quantidade && (
                <Typography>
                  Quantidade Alocada: {investidor.quantidade}
                </Typography>
              )}
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

const EventosFinanceiros: React.FC = () => {
  const dataGridApiRef = React.useRef<any>(null);
  const [openValidarLiquidacaoDrawer, setOpenValidarLiquidacaoDrawer] = useState(false);
  const [openEventoExtraordinarioDrawer, setOpenEventoExtraordinarioDrawer] = useState(false);
  const [pagamentoParaReenvio, setPagamentoParaReenvio] = useState<PagamentoResponse>();
  const [openSolicitarLiquidacaoDrawer, setOpenSolicitarLiquidacaoDrawer] = useState(false);
  const [openConfirmarLiquidacaoDrawer, setOpenConfirmarLiquidacaoDrawer] = useState(false);
  const [openAnexarComprovanteDrawer, setOpenAnexarComprovanteDrawer] = useState<boolean>(false);
  const [openRevisarAgenteFiduciarioDrawer, setOpenRevisarAgenteFiduciarioDrawer] = useState<boolean>(false);
  const [openSolicitarLiquidacaoBrutaEmissorDrawer, setOpenSolicitarLiquidacaoBrutaEmissorDrawer] = useState<boolean>(false);
  const [openSolicitarLiquidacaoBrutaAFDrawer, setOpenSolicitarLiquidacaoBrutaAFDrawer] = useState<boolean>(false);
  const [openHistoricoPUsDrawer, setOpenHistoricoPUsDrawer] = useState<boolean>(false);
  const [selectedPagamento, setSelectedPagamento] = useState<PagamentoResponse>();
  const [pagamentoDocuments, setPagamentoDocuments] = useState<Array<PagamentoDocuments>>();
  const [pagamentoSolicitado, setPagamentoSolicitado] = useState(false);
  const [pagamentoRejeitado, setPagamentoRejeitado] = useState(false);
  const [liquidacaoConfirmada, setLiquidacaoConfirmada] = useState(false);
  const [codigoPagamentoAguardandoLiquidacao, setCodigoPagamentoAguardandoLiquidacao] = useState<string>();
  const [codigoPagamentoLiquidado, setCodigoPagamentoLiquidado] = useState<string>();
  const [rejectPagamento, setRejectPagamento] = useState(false);
  const [contestarPagamento, setContestarPagamento] = useState(false);
  const [liquidacaoDireta, setLiquidacaoDireta] = useState(true);
  const [multa, setMulta] = useState<number>(0);
  const [expandedDetailPanels, setExpandedDetailPanels] = useState<GridRowId[]>([]);
  const [mora, setMora] = useState<number>(0);
  const [valorUnitarioPagamento, setValorUnitarioPagamento] = useState<number>(0);
  const [valorPagamentoCalculado, setValorPagamentoCalculado] = useState<number>(0);
  const [percentual, setPercentual] = useState<number>(0);
  const [percentualCalculado, setPercentualCalculado] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [valorUnitarioEmissao, setValorUnitarioEmissao] = useState<number>(0);
  const [tipoLancamento, setTipoLancamento] = useState<TipoLancamento>(TipoLancamento.ValorPagamento);
  const [page, setPage] = useState<number>(0);
  const [linkOperator, setLinkOperator] = useState<any>("AND");
  const [pageCount, setPageCount] = useState<number>(0);
  const [pagamentosPaginated, setPagamentosPaginated] = useState<Array<PagamentoResponse>>([])
  const [topFilters, setTopFilters] = useState<Array<EventosFinanceirosFilter>>([]);
  const [tableFilters, setTableFilters] = useState<Array<EventosFinanceirosFilter>>([]);
  const [eventosFinanceirosFilter, setEventosFinanceirosFilter] = useState<Array<EventosFinanceirosFilter>>([]);
  const [attachments, setAttachments] = useState<Attachment[]>();
  const [refresh, setRefresh] = useState([]);
  const [filterDataFrom, setFilterDataFrom] = useState<string>('');
  const [filterDataTo, setFilterDataTo] = useState<string>('');
  const [filterCodigoIF, setFilterCodigoIF] = useState<string>('');
  const [filterInvestidor, setFilterInvestidor] = useState<string>('');
  const [filterInadimplente, setFilterInadimplente] = useState<boolean | undefined>();
  const [selectedPagamentos, setSelectedPagamentos] = useState<Array<string>>([]);
  const [showLiquidacaoEmLote, setShowLiquidacaoEmLote] = useState<boolean>(false);
  const [liquidacaoEmLoteItens, setLiquidacaoEmLoteItens] = useState<Array<LiquidacaoEmLoteItem>>([]);
  const [openLiquidacaoEmLoteModal, setOpenLiquidacaoEmLoteModal] = useState<boolean>(false);
  const [liquidacaoEmLoteFile, setLiquidacaoEmLoteFile] = useState<Files[]>([]);
  const [isProcessingUpload, setIsProcessingUpload] = useState<boolean>(false);
  const [consultaFeedback, setConsultaFeedback] = useState<FeedbackLoteData | null>(null);
  const [puRemanescenteApurado, setPuRemanescenteApurado] = useState<number>(0);
  const [currentEmail, setCurrentEmail] = useState<string>();
  const [instrumentoEmails, setInstrumentoEmails] = useState<Array<string>>([]);
  const [isInadimplente, setIsInadimplente] = useState<boolean | undefined>();
  const [apiDataFrom, setApiDataFrom] = useState<Date | null | undefined>(undefined);
  const [apiDataTo, setApiDataTo] = useState<Date | null | undefined>(undefined);
  const [indicarOutroValor, setIndicarOutroValor] = useState<boolean>(false);
  const classes = useGenericStyles();
  const dispatch = useDispatch();
  const {
    getPagamentos: getPagamentoApi,
    postSolicitarLiquidacaoPagamento,
    postSolicitarAprovarConfirmarLiquidacaoPagamento,
    postSolicitarAprovarConfirmarLiquidacaoEmLote,
    postCancelarSolicitacaoEvento
  } = useSelector((state: RootState) => state.instrumentoApi);

  const { getPagamento: getPagamentoSelected } = useSelector((state: RootState) => state.instrumentoApi);

  const postEventosFinanceirosApi = useSelector(
    (state: RootState) => state.instrumentoApi.postEventosFinanceirosPaginated
  );
  const getPagamentoDocumentsApi = useSelector((state: RootState) => state.instrumentoApi.getPagamentoDocuments);

  const isParticipanteEmissor =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Emissor;
  const isParticipanteCredenciado =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Credenciado;
  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isUsuarioCadastroOperacoes = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.CadastroOperacoes
  );
  const isParticipanteAgenteFiduciario = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.AgenteFiduciario
  );
  const isParticipanteCustodiante =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Custodiante;
  const isParticipanteEscriturador =
    useSelector((state: RootState) => state.auth.usuario.participante.funcao) === FuncaoParticipante.Escriturador;
  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);
  const auth = useSelector((state: RootState) => state.auth);
  const usuarioLogado = {
    grupoAcesso: auth.usuario.grupoAcesso,
    funcao: auth.usuario.participante.funcao,
    perfil: auth.usuario.participante.perfil,
  };
  const [pageSize, setPageSize] = React.useState(20);

  const getStatusIcon = useCallback(
    (status: PagamentoStatus) => {
      switch (status) {
        case PagamentoStatus.PendenteAprovacao:
        case PagamentoStatus.AguardandoLiquidacao:
        case PagamentoStatus.AguardandoComprovante:
        case PagamentoStatus.Previsto:
          return <WatchLater fontSize="small" className={classes.warningIcon} />;
        case PagamentoStatus.PendenteAprovacaoAgenteFiduciario:
          return <HourglassEmpty fontSize="small" className={classes.waitingIcon} />;
        case PagamentoStatus.Concluida:
          return <CheckCircle fontSize="small" className={classes.successIcon} />;
        case PagamentoStatus.ParcialmenteConcluida:
          return <CheckCircle fontSize="small" className={classes.warningIcon} />;
        case PagamentoStatus.ReprovadoAgenteFiduciario:
          return <ThumbDown fontSize="small" className={classes.errorIcon} />;
        case PagamentoStatus.Reprovada:
        case PagamentoStatus.Cancelada:
          return <Cancel fontSize="small" className={classes.errorIcon} />;
        default:
          return <></>;
      }
    },
    [classes]
  );

  const postPagamentos = useCallback(async () => {
    try {
      setLoading(true);
      const query: {
        page: number;
        pageSize: number;
        linkOperator: any;
        eventosFinanceirosFilter: EventosFinanceirosFilter[];
        inadimplente: boolean | undefined;
        dataFrom: Date | null | undefined;
        dataTo: Date | null | undefined;
        distribuicaoPublica?: boolean | undefined;
      } = {
        page: page + 1,
        pageSize,
        linkOperator: linkOperator,
        eventosFinanceirosFilter: eventosFinanceirosFilter,
        inadimplente: isInadimplente,
        dataFrom: apiDataFrom,
        dataTo: apiDataTo
      }

      const result = await postEventosFinanceirosApi(
        dispatch,
        query,
        true
      );

      setPagamentosPaginated(result.result);
      setPageCount(result.totalCount);
      setLoading(false);
    } catch { }
  }, [eventosFinanceirosFilter, pageSize, page, linkOperator, isInadimplente, apiDataFrom, apiDataTo]);

  const getSelectedPagamento = useCallback(async (pagamentoId) => {
    try {
      setLoading(true);
      const result = await getPagamentoSelected(
        dispatch,
        pagamentoId,
        true
      );
      setSelectedPagamento(result)
      setInstrumentoEmails(result?.instrumentoFinanceiro.emails ?? []);
      setLoading(false);
    } catch { }
  }, [eventosFinanceirosFilter, pageSize, page, linkOperator]);

  useEffect(() => {
    postPagamentos();
  }, [postPagamentos, refresh]);

  useEffect(() => {
    if (selectedPagamento && selectedPagamento?.status === PagamentoStatus.AguardandoComprovante) setTipoLancamento(TipoLancamento.ValorPagamento);
    setValorUnitarioEmissao(selectedPagamento ? selectedPagamento.instrumentoFinanceiro.valorNominalUnitarioEmissao : 0);
    setValorPagamentoCalculado(0);
    setPercentual(selectedPagamento?.status !== PagamentoStatus.AguardandoComprovante && selectedPagamento?.percentual ? selectedPagamento?.percentual : 0);
    setPercentualCalculado(0);
    setMulta(selectedPagamento?.valorMulta ?? 0);
    setMora(selectedPagamento?.valorMora ?? 0);
    setLiquidacaoDireta(true);
    setIndicarOutroValor(false);

    if (selectedPagamento?.tipo === PagamentoTipo.Juros && selectedPagamento?.puDiario && selectedPagamento.puDiario > 0) {
      const valorTotal = selectedPagamento.puDiario * selectedPagamento.instrumentoFinanceiro.quantidadeEmitida;
      handleFeesCalculator(valorTotal, selectedPagamento);
    } else {
      setValorUnitarioPagamento(selectedPagamento?.status === PagamentoStatus.AguardandoComprovante && selectedPagamento?.valorPagamento ? selectedPagamento.valorPagamento : 0);
    }
  }, [openSolicitarLiquidacaoDrawer, selectedPagamento, setValorUnitarioPagamento, setLiquidacaoDireta]);

  const handleCancelarSolicitacaoEvento = async (pagamento: PagamentoResponse) => {
    try {
      await postCancelarSolicitacaoEvento(dispatch, pagamento.id, true);
      postPagamentos();
    } catch { }
  };

  const handleSubmitEventoExtraordinarioSuccess = (codigoInstrumento: string) => {
    setCodigoPagamentoLiquidado(codigoInstrumento);
    setOpenEventoExtraordinarioDrawer(false);
    setPagamentoParaReenvio(undefined);
    postPagamentos();
  };

  const handleSubmitValidarLiquidacaoSuccess = (reject = false) => {
    reject ? setPagamentoRejeitado(true) : setPagamentoSolicitado(true);
    setOpenValidarLiquidacaoDrawer(false);
    postPagamentos();
  };

  const handleSubmitConfirmarLiquidacaoSuccess = (reject = false) => {
    setLiquidacaoConfirmada(true);
    setOpenConfirmarLiquidacaoDrawer(false);
    postPagamentos();
  };

  const handleSolicitarLiquidacao = async () => {
    try {
      if (!selectedPagamento) return;

      if (selectedPagamento.tipo === PagamentoTipo.Juros && !valorUnitarioPagamento) {
        dispatch(addAlert({ severity: "error", message: "O valor unitário de pagamento não pode ser zero." }));
        return;
      }

      const request: PagamentoSolicitarLiquidacaoRequest = {
        valorPagamento: selectedPagamento.tipo === PagamentoTipo.Amortizacao && tipoLancamento === TipoLancamento.Percentual ? valorPagamentoCalculado : valorUnitarioPagamento,
        liquidacaoDireta,
        percentual: selectedPagamento.tipo === PagamentoTipo.Amortizacao && tipoLancamento === TipoLancamento.ValorPagamento ? percentualCalculado : percentual,
        valorMulta: selectedPagamento.inadimplente ? multa : undefined,
        valorMora: selectedPagamento.inadimplente ? mora : undefined,
        emails: instrumentoEmails
      };

      if (liquidacaoDireta) {
        await postSolicitarAprovarConfirmarLiquidacaoPagamento(dispatch, selectedPagamento.id, request, attachments?.map((attachment: Files) => attachment.file!), true);
        setCodigoPagamentoLiquidado(selectedPagamento?.instrumentoFinanceiro.codigo);
      } else {
        await postSolicitarLiquidacaoPagamento(dispatch, selectedPagamento.id, request, attachments?.map((attachment: Files) => attachment.file!), true);
        setCodigoPagamentoAguardandoLiquidacao(selectedPagamento?.instrumentoFinanceiro.codigo);
      }

      handleCloseSolicitarLiquidacaoDrawer();
      setRefresh([]);
    } catch (error) { }
  };

  const handleOpenValidarLiquidacaoDrawer = (pagamentoResponse: PagamentoResponse, reject = false) => {
    const pagamentoAtual = getSelectedPagamento(pagamentoResponse.id);
    setRejectPagamento(reject);
    setOpenValidarLiquidacaoDrawer(true);
  };

  const handleOpenSolicitarLiquidacaoDrawer = async (pagamentoResponse: PagamentoResponse) => {
    await getSelectedPagamento(pagamentoResponse.id);
    setOpenSolicitarLiquidacaoDrawer(true);
  };

  const handleOpenConfirmarLiquidacaoDrawer = async (pagamentoResponse: PagamentoResponse, reject = false) => {
    const response = await getPagamentoDocumentsApi(dispatch, pagamentoResponse.id);
    const pagamentoAtual = getSelectedPagamento(pagamentoResponse.id);
    setPagamentoDocuments(response);
    setRejectPagamento(reject);
    setContestarPagamento(false);
    setOpenConfirmarLiquidacaoDrawer(true);
  };

  const handleOpenContestarPagamentoDrawer = async (pagamentoResponse: PagamentoResponse) => {
    setContestarPagamento(true)
    setSelectedPagamento(pagamentoResponse);
    setOpenConfirmarLiquidacaoDrawer(true);
  };

  const handleOpenRevisarAgenteFiduciarioDrawer = async (pagamentoResponse: PagamentoResponse) => {
    const response = await getPagamentoDocumentsApi(dispatch, pagamentoResponse.id);
    const pagamentoAtual = getSelectedPagamento(pagamentoResponse.id);
    setPagamentoDocuments(response);
    setOpenRevisarAgenteFiduciarioDrawer(true);
  };

  const handleOpenSolicitarLiquidacaoBrutaEmissorDrawer = (pagamentoResponse: PagamentoResponse) => {
    getSelectedPagamento(pagamentoResponse.id);
    setOpenSolicitarLiquidacaoBrutaEmissorDrawer(true);
  };

  const handleCloseSolicitarLiquidacaoBrutaEmissorDrawer = () => {
    setSelectedPagamento(undefined);
    setOpenSolicitarLiquidacaoBrutaEmissorDrawer(false);
  };

  const handleOpenSolicitarLiquidacaoBrutaAFDrawer = (pagamentoResponse: PagamentoResponse) => {
    getSelectedPagamento(pagamentoResponse.id);
    setOpenSolicitarLiquidacaoBrutaAFDrawer(true);
  };

  const handleCloseSolicitarLiquidacaoBrutaAFDrawer = () => {
    setSelectedPagamento(undefined);
    setOpenSolicitarLiquidacaoBrutaAFDrawer(false);
  };

  const handleOpenHistoricoPUsDrawer = async (pagamentoResponse: PagamentoResponse) => {
    await getSelectedPagamento(pagamentoResponse.id);
    setOpenHistoricoPUsDrawer(true);
  };

  const handleCloseHistoricoPUsDrawer = () => {
    setSelectedPagamento(undefined);
    setOpenHistoricoPUsDrawer(false);
  };

  const handleCloseSolicitarLiquidacaoDrawer = () => {
    setSelectedPagamento(undefined);
    setInstrumentoEmails([]);
    setOpenSolicitarLiquidacaoDrawer(false);
    setAttachments([]);
    setCurrentEmail('');
    setIndicarOutroValor(false);
  };

  const handleOpenAnexarComprovanteDrawer = async (pagamentoResponse: PagamentoResponse) => {
    const response = await getPagamentoDocumentsApi(dispatch, pagamentoResponse.id);
    const pagamentoAtual = getSelectedPagamento(pagamentoResponse.id);
    setPagamentoDocuments(response);
    setOpenAnexarComprovanteDrawer(true);
  };

  const handleCloseAnexarComprovanteDrawer = () => {
    setPagamentoDocuments(undefined);
    setSelectedPagamento(undefined);
    setOpenAnexarComprovanteDrawer(false);
  };

  const handleAnexarComprovanteSuccess = async () => {
    if (selectedPagamento) {
      const response = await getPagamentoDocumentsApi(dispatch, selectedPagamento.id);
      setPagamentoDocuments(response);
    }
    postPagamentos();
  };

  const handleCloseConfirmarLiquidacaoDrawer = () => {
    setPagamentoDocuments(undefined);
    setSelectedPagamento(undefined);
    setInstrumentoEmails([]);
    setOpenConfirmarLiquidacaoDrawer(false);
    setCurrentEmail('');
    setContestarPagamento(false);
  };

  const handleCloseRevisarAgenteFiduciarioDrawer = () => {
    setPagamentoDocuments(undefined);
    setSelectedPagamento(undefined);
    setInstrumentoEmails([]);
    setOpenRevisarAgenteFiduciarioDrawer(false);
    setCurrentEmail('');
  };

  const handleAttachmentsChange = (newAttachments: Attachment[]) => {
    const updatedAttachments = (attachments ?? []).concat(newAttachments);
    setAttachments(updatedAttachments);
  };

  const handleRemoveClick = (id: string) => {
    const updatedAttachments = attachments?.filter((attachment) => attachment.id !== id);
    setAttachments(updatedAttachments);
  };

  const handleFeesCalculator = (value: number, selectedPagamento: PagamentoResponse) => {

    const quantidadeEmitida = selectedPagamento.instrumentoFinanceiro.quantidadeEmitida;

    var juros = value / quantidadeEmitida;

    setValorUnitarioPagamento(juros ?? 0)
  }

  const getCalcularAmortizacao = useSelector((state: RootState) => state.instrumentoApi.getCalcularAmortizacao);

  const getCalculoPercentual = useCallback(async () => {
    var request = { percentual: undefined, valorPagamento: valorUnitarioPagamento, valorUnitario: valorUnitarioEmissao, puRemanescente: selectedPagamento?.instrumentoFinanceiro.puRemanescente };
    try {
      const result = await getCalcularAmortizacao(dispatch, request, false);
      setPercentualCalculado(result.percentual);
      setPuRemanescenteApurado(result.puRemanescenteApurado)
    } catch (error) { }
  }, [valorUnitarioPagamento, tipoLancamento, valorUnitarioEmissao, selectedPagamento]);

  const getCalculoValorPagamento = useCallback(async () => {
    var request = { percentual, valorPagamento: undefined, valorUnitario: valorUnitarioEmissao, puRemanescente: selectedPagamento?.instrumentoFinanceiro.puRemanescente };
    try {
      const result = await getCalcularAmortizacao(dispatch, request, false);
      setValorPagamentoCalculado(result.valorPagamento);
      setPuRemanescenteApurado(result.puRemanescenteApurado)
    } catch (error) { }
  }, [percentual, tipoLancamento, valorUnitarioEmissao, selectedPagamento]);

  useEffect(() => {
    if (openSolicitarLiquidacaoDrawer && tipoLancamento === TipoLancamento.ValorPagamento
      && selectedPagamento?.tipo !== PagamentoTipo.Juros)
      getCalculoPercentual();
  }, [valorUnitarioPagamento, tipoLancamento, openSolicitarLiquidacaoDrawer, selectedPagamento]);

  useEffect(() => {
    if (openSolicitarLiquidacaoDrawer && tipoLancamento === TipoLancamento.Percentual
      && selectedPagamento?.tipo !== PagamentoTipo.Juros)
      getCalculoValorPagamento();
  }, [percentual, tipoLancamento, openSolicitarLiquidacaoDrawer, selectedPagamento]);

  const sugestaoJuros = () => {
    if (!selectedPagamento) return null;

    const puJuros = selectedPagamento.puDiario;
    const quantidade = selectedPagamento.instrumentoFinanceiro.quantidadeEmitida;

    if (!puJuros || puJuros === 0) {
      return (
        <Typography>
          {'Não foi possível calcular o valor de juros, informe manualmente.'}
          <SmSpace />
        </Typography>
      );
    }

    const valorTotalSugerido = puJuros * quantidade;

    return (
      <>
        <Typography>
          {`Sugestão de valor unitário de juros previsto: R$ ${puJuros.toFixed(8)}`}
          <SmSpace />
          {`Valor total sugerido: R$ ${valorTotalSugerido.toFixed(8)}`}
          <SmSpace />
        </Typography>
      </>
    );
  }

  const instrumentoEmailsList = () => {
    if ((isUsuarioOperacoes || isUsuarioCadastroOperacoes) && selectedPagamento) {
      const cadastrados = instrumentoEmails.map((email: string, index: number) => {
        return (
          <>
            <div style={{ paddingLeft: "5px", display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }} >
              <Typography style={{ width: "100%" }} variant={"body1"}>{email}</Typography>
              <Button
                variant="contained"
                color="error"
                style={{ minWidth: '0', width: '40px', minHeight: '0', height: '40px', marginLeft: '10px' }}
                onClick={() => handleRemoveEmail(index)}
              >
                <RemoveIcon />
              </Button>
            </div>
            <SmSpace />
          </>
        )
      });

      return (
        <div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }} >
            <TextField label="Email" value={currentEmail} onChange={setCurrentEmail} />
            <Button
              variant="contained"
              color="primary"
              style={{ minWidth: '0', width: '40px', minHeight: '0', height: '40px', marginLeft: '10px' }}
              onClick={handleAddEmail}
            >
              <AddIcon />
            </Button>
          </div>
          <SmSpace />
          {cadastrados}
          <LgSpace />
        </div>
      )
    }
  }

  const handleAddEmail = () => {
    if (currentEmail && currentEmail !== "") {
      if (!validaEmail(currentEmail)) {
        dispatch(addAlert({ severity: 'error', message: errorMessages.instrumentoFinanceiro.eventosFinanceiros.emailInvalido }));
        return;
      }

      if (instrumentoEmails.includes(currentEmail)) {
        dispatch(addAlert({ severity: 'error', message: errorMessages.instrumentoFinanceiro.eventosFinanceiros.emailDuplicado }));
        return;
      }

      const newEmails = [currentEmail, ...instrumentoEmails];
      setInstrumentoEmails(newEmails);
      setCurrentEmail('');
    }
  };

  const handleRemoveEmail = (indice: number) => {
    const newEmails = instrumentoEmails.filter((email, index) => { return index !== indice });
    setInstrumentoEmails(newEmails)
  };

  const SolicitarLiquidacaoDrawer = (
    <GenericDrawer
      opened={openSolicitarLiquidacaoDrawer}
      onClose={handleCloseSolicitarLiquidacaoDrawer}
      title={selectedPagamento?.status === PagamentoStatus.AguardandoComprovante ? `Anexar Comprovante` : `Solicitar Liquidação`}
      textContents={[
        {
          text: `A Laqus Central Depositária S/A, poderá, conforme Regulamento e Manuais, solicitar a comprovação financeira da operação a qualquer momento e a seu exclusivo critério.`
        },
      ]}
      buttons={[
        {
          buttonText: `Aceitar e Solicitar Liquidação`,
          buttonAction: handleSolicitarLiquidacao,
          buttonColor: 'primary',
        },
        {
          buttonText: 'Cancelar',
          buttonAction: handleCloseSolicitarLiquidacaoDrawer,
        },
      ]}
    >
      {(selectedPagamento?.tipo === PagamentoTipo.Amortizacao ||
        selectedPagamento?.tipo === EventoExtraordinarioTipo.Amortizacao) && (
          <>
            <RadioButton
              label={"Tipo de Lançamento"}
              options={tipoLancamentoOptions}
              value={tipoLancamento}
              onChange={(value: string) => setTipoLancamento(value as TipoLancamento)}
              inline
            />
            <SmSpace />
            <NumberField
              label={'Percentual'}
              value={tipoLancamento === TipoLancamento.Percentual ? percentual : percentualCalculado}
              required
              onChange={(value) => tipoLancamento === TipoLancamento.Percentual ? setPercentual(value ?? 0) : null}
              numberType="eightDecimals"
              adornment={'%'}
              adornmentPosition={'end'}
              disabled={tipoLancamento === TipoLancamento.ValorPagamento}
            />
            <SmSpace />
            <NumberField
              label={'Valor Unitário de Pagamento'}
              value={tipoLancamento === TipoLancamento.Percentual ? valorPagamentoCalculado : valorUnitarioPagamento}
              required
              onChange={(value) => tipoLancamento === TipoLancamento.Percentual ? null : setValorUnitarioPagamento(value ?? 0)}
              numberType="eightDecimals"
              disabled={tipoLancamento === TipoLancamento.Percentual}
            />
            <SmSpace />
            <Typography variant='body1'>
              {`Saldo Preço Unitário Remanescente: R$ ${puRemanescenteApurado.toFixed(8)}`}
              <SmSpace />
            </Typography>
            {selectedPagamento?.ultimoPagamento && puRemanescenteApurado !== 0 &&
              <div
                style={{
                  marginBottom: '20px',
                  padding: '20px',
                  border: '2px solid #FFCF40',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <ErrorIcon style={{ marginRight: 10 }} fontSize="small" />
                <Typography variant="body1">
                  {`ATENÇÃO Evento ${selectedPagamento?.instrumentoFinanceiro.codigo} será liquidado com valor residual. Tem certeza que deseja continuar?`}
                </Typography>
              </div>
            }
          </>

        )}
      {selectedPagamento?.tipo === PagamentoTipo.Juros && (
        <>
          {sugestaoJuros()}
          <NumberField
            label={'Valor total de pagamento'}
            value={(!indicarOutroValor && selectedPagamento?.puDiario && selectedPagamento.puDiario > 0)
              ? selectedPagamento.puDiario * selectedPagamento.instrumentoFinanceiro.quantidadeEmitida
              : 0}
            required
            onChange={(value) => handleFeesCalculator(value ?? 0, selectedPagamento)}
            numberType="eightDecimals"
            adornmentPosition={'end'}
            disabled={!indicarOutroValor && !!selectedPagamento?.puDiario && selectedPagamento.puDiario > 0}
          />
          <SmSpace />
          <NumberField
            label={'Valor Unitário de Pagamento'}
            value={valorUnitarioPagamento ?? 0}
            required
            onChange={() => { }}
            numberType="eightDecimals"
            disabled={true}
          />
          <SmSpace />
          {!!selectedPagamento?.puDiario && selectedPagamento.puDiario > 0 && (
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  checked={indicarOutroValor}
                  onChange={() => {
                    setIndicarOutroValor(!indicarOutroValor);
                    if (!indicarOutroValor) setValorUnitarioPagamento(0);
                  }}
                />
              }
              label={
                <Typography variant="body2">
                  Indicar outro valor
                </Typography>
              }
            />
          )}
          <SmSpace />
        </>
      )}
      {selectedPagamento?.inadimplente && (
        <>
          <NumberField
            label={'Multa'}
            value={multa}
            onChange={(value) => setMulta(value ?? 0)}
            numberType="eightDecimals"
          />
          <SmSpace />
          <NumberField
            label={'Mora'}
            value={mora}
            onChange={(value) => setMora(value ?? 0)}
            numberType="eightDecimals"
          />
          <SmSpace />
        </>
      )}
      <SmSpace />
      <UploadDocs onChange={handleAttachmentsChange} onDelete={handleRemoveClick} multipleFiles={true} />
      {deveExibirAvisoConfirmacaoAgenteFiduciario(valorUnitarioPagamento, selectedPagamento?.instrumentoFinanceiro) && (
        <div
          style={{
            marginBottom: '20px',
            padding: '20px',
            border: '2px solid #FFCF40',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ErrorIcon style={{ marginRight: 10 }} fontSize="small" />
          <Typography variant="body1">
            {
              'O valor deve ser confirmado com o Agente Fiduciário e caso exista divergência do valor informado, o lançamento poderá ser rejeitado.'
            }
          </Typography>
        </div>
      )}
      {instrumentoEmailsList()}
    </GenericDrawer>
  );

  const onFilterChange = useCallback(
    (filterModel: GridFilterModel) => {
      if (!filterModel || !filterModel.items || filterModel.items.length === 0) {
        setTableFilters([]);
        setEventosFinanceirosFilter([...topFilters]);
        return;
      }
      setLinkOperator(filterModel?.linkOperator?.toString()?.toUpperCase() ?? "AND");
      var newTableFilters = new Array<EventosFinanceirosFilter>();

      filterModel.items.forEach(filter => {
        let operatorValue =
          filter.operatorValue == 'startsWith'
            ? 'STARTS_WITH'
            : filter.operatorValue == 'endsWith'
              ? 'ENDS_WITH'
              : filter.operatorValue?.toUpperCase();

        let formattedValue = filter.value?.toString()
        if (formattedValue) {
          if (filter.columnField == "TIPO_INSTRUMENTO_FINANCEIRO") {
            formattedValue = formattedValue.replace("_", " ");
          }

          if (filter.columnField == 'DATA_VENCIMENTO' || filter.columnField == 'DATA_LIQUIDACAO') {
            formattedValue = formattedValue.split('-');
            formattedValue = `${formattedValue[2]}/${formattedValue[1]}/${formattedValue[0]}`;
          }

          if (filter.columnField == 'DOCUMENTO_EMISSOR') {
            formattedValue = formattedValue.replace(/\D/g, '');
          }

          let params = {
            columnType: filter.columnField.toUpperCase(),
            operationFilterType: operatorValue,
            value: formattedValue,
          } as EventosFinanceirosFilter;

          newTableFilters.push(params);
        }
      });
      setTableFilters(newTableFilters);
      setEventosFinanceirosFilter([...topFilters, ...newTableFilters]);
    },
    [page, pageSize, linkOperator, topFilters]
  );

  const onSortChange = useCallback(
    (filterModel: GridSortModel) => {
      if (!filterModel || filterModel.length === 0) return;

      var filter = filterModel[0];
      if (!filter || !filter.field) return;

      let params = {
        columnType: filter.field.toUpperCase(),
        orderByType: filter.sort?.toUpperCase(),
      } as EventosFinanceirosFilter;

      var newEFFilter = eventosFinanceirosFilter.filter(x => x.orderByType != "ASC" && x.orderByType != "DESC") as Array<EventosFinanceirosFilter>;
      newEFFilter.push(params);
      setEventosFinanceirosFilter([...newEFFilter]);
    },
    [page, pageSize, eventosFinanceirosFilter]
  );

  const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains', 'startsWith', 'endsWith'].includes(value)
  );

  const filterOperatorsData = getGridDateOperators().filter(({ value }) =>
    ["is", "not", "after", "onOrAfter", "before", "onOrBefore"].includes(value)
  );

  const handleOpenLiquidacaoEmLoteModal = () => {
    setOpenLiquidacaoEmLoteModal(true);
    setLiquidacaoEmLoteFile([]);
  };

  const handleCloseLiquidacaoEmLoteModal = () => {
    setOpenLiquidacaoEmLoteModal(false);
    setLiquidacaoEmLoteFile([]);
  };

  const handleDownloadModeloLiquidacaoEmLote = async () => {
    try {
      const response = await GETModeloLiquidacaoEmLote(dispatch, true);
      const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'modeloLiquidacaoLote.xlsx';
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error: any) {
      dispatch(addAlert({ message: 'Erro ao baixar modelo. Tente novamente.', severity: 'error' }));
    }
  };

  const mapearErrosConsultaLote = (erros: Array<{ codigo: string; tipo: string; dataVencimento: string; erro: string }>) =>
    erros.map((e) => ({
      identificador: e.codigo,
      campos: [
        { label: 'Código IF', valor: e.codigo },
        { label: 'Tipo', valor: e.tipo },
        { label: 'Data Vencimento', valor: e.dataVencimento },
      ],
      mensagemErro: e.erro,
    }));

  const handleLiquidarEmLoteUpload = async () => {
    if (liquidacaoEmLoteFile.length === 0 || !liquidacaoEmLoteFile[0].file) {
      dispatch(addAlert({ message: 'Selecione um arquivo para continuar', severity: 'error' }));
      return;
    }

    setIsProcessingUpload(true);

    try {
      const parsedRows = await parseLiquidacaoEmLoteExcel(liquidacaoEmLoteFile[0].file);
      const apiRequest = buildLiquidacaoEmLoteRequest(parsedRows);

      const consultaResponse: LiquidacaoEmLoteConsultaResponse = await POSTConsultarLiquidacaoEmLote(dispatch, apiRequest, true);

      const liquidacaoItens: LiquidacaoEmLoteItem[] = consultaResponse.sucessos.map((item) => {
        const excelRow = parsedRows.find(
          (r) => r.codigo === item.codigo && r.dataVencimento === item.dataVencimento && r.tipo === item.tipo
        );

        return {
          id: item.id,
          codigo: item.codigo,
          tipo: item.tipo as PagamentoTipo,
          tipoInstrumentoFinanceiro: item.tipoInstrumentoFinanceiro,
          puAtualizado: item.puAtualizado,
          puMulta: item.puMulta,
          puMora: item.puMora,
          dataVencimento: item.dataVencimento,
          liquidacaoDireta: excelRow?.liquidacaoDireta ?? true,
        };
      });

      setLiquidacaoEmLoteItens(liquidacaoItens);
      setOpenLiquidacaoEmLoteModal(false);

      if (consultaResponse.erros && consultaResponse.erros.length > 0) {
        setConsultaFeedback({
          status: liquidacaoItens.length > 0 ? 'PARCIAL' : 'FALHA',
          titulo: liquidacaoItens.length > 0
            ? 'Alguns itens não puderam ser processados'
            : 'Nenhum item pôde ser processado',
          resumo: {
            totalProcessados: parsedRows.length,
            totalSucesso: consultaResponse.sucessos.length,
            totalFalha: consultaResponse.erros.length,
          },
          erros: mapearErrosConsultaLote(consultaResponse.erros),
        });
      }

      if (liquidacaoItens.length > 0) {
        setShowLiquidacaoEmLote(true);
        dispatch(addAlert({
          message: `Arquivo processado: ${liquidacaoItens.length} eventos carregados com sucesso.`,
          severity: consultaResponse.erros.length > 0 ? 'warning' : 'success',
        }));
      }
    } catch (error: any) {
      setOpenLiquidacaoEmLoteModal(false);

      const errorResponse = error?.response?.data;
      if (errorResponse?.erros && Array.isArray(errorResponse.erros)) {
        setConsultaFeedback({
          status: 'FALHA',
          titulo: 'Nenhum item pôde ser processado',
          resumo: {
            totalProcessados: errorResponse.erros.length,
            totalSucesso: 0,
            totalFalha: errorResponse.erros.length,
          },
          erros: mapearErrosConsultaLote(errorResponse.erros),
        });
      } else {
        dispatch(addAlert({
          message: error.message || 'Erro ao processar arquivo',
          severity: 'error',
        }));
      }
    } finally {
      setIsProcessingUpload(false);
    }
  };

  const getGridColumns = useCallback(
    () => [
      {
        field: 'STATUS',
        headerName: 'Status',
        filterOperators,
        width: 125,
        minWidth: 125,
        maxWidth: 200,
        valueGetter: (params: GridValueGetterParams) => (params.row as PagamentoResponse).status,
        renderCell: (params: GridCellParams) => {
          const pagamento = params.row as PagamentoResponse;
          const tooltipText = pagamento.status === PagamentoStatus.Reprovada && pagamento.motivoReprovacao
            ? `${pagamentoStatusDescriptions[pagamento.status]} - Motivo: ${pagamento.motivoReprovacao}`
            : pagamentoStatusDescriptions[pagamento.status];
          return (
            <>
              <Tooltip
                title={tooltipText}
                aria-label={tooltipText}
              >
                {getStatusIcon(pagamento.status)}
              </Tooltip>
              {pagamento.inadimplente && (
                <div style={{ display: 'flex', alignItems: 'center', width: 40 }}>
                  <Tooltip title={'Inadimplente'} aria-label={'Inadimplente'}>
                    <Error fontSize="small" className={classes.errorIcon} />
                  </Tooltip>
                </div>
              )}
            </>
          );
        },
      },
      {
        field: 'CODIGO',
        headerName: 'Código',
        filterOperators,
        valueGetter: (params: GridValueGetterParams) => (params.row as PagamentoResponse).instrumentoFinanceiro.codigo,
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },

      {
        field: 'TIPO_INSTRUMENTO',
        headerName: 'Tipo Instrumento',
        filterOperators,
        valueGetter: (params: GridValueGetterParams) =>
          getInstrumentoFinanceiroLongDescription[(params.row as PagamentoResponse).instrumentoFinanceiro.tipoInstrumentoFinanceiro],
        width: 210,
        minWidth: 150,
        maxWidth: 250,
      },
      {
        field: 'EMISSAO',
        headerName: 'Emissão',
        filterOperators,
        valueGetter: (params: GridValueGetterParams) => {
          const row = params.row as PagamentoResponse;
          return row.instrumentoFinanceiro.numeroEmissao;
        },
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'RAZAO_EMISSOR',
        headerName: 'Razão Social do Emissor',
        filterOperators,
        valueGetter: (params: GridValueGetterParams) => {
          const row = params.row as PagamentoResponse;
          return row.instrumentoFinanceiro.emissor?.razaoSocial;
        },
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'DOCUMENTO_EMISSOR',
        headerName: 'CNPJ do Emissor',
        filterOperators,
        valueGetter: (params: GridValueGetterParams) => {
          const row = params.row as PagamentoResponse;
          return addCpfCnpjMask(row.instrumentoFinanceiro.emissor?.cnpj! ?? '');
        },
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'TIPO_EVENTO_FINANCEIRO',
        headerName: 'Evento',
        filterOperators,
        valueGetter: (params: GridValueGetterParams) =>
          eventoFinanceiroDescriptions[(params.row as PagamentoResponse).tipo],
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'VALOR_UNITARIO_PAGAMENTO',
        headerName: 'Valor Unitário de Pagamento',
        filterOperators,
        valueGetter: (params: GridValueGetterParams) => {
          const pagamento = params.row as PagamentoResponse;
          return pagamento.valorPagamento ? formatEightDecimalsCurrency(pagamento.valorPagamento) : '';
        },
        width: 150,
        minWidth: 200,
        maxWidth: 400,
      },
      {
        field: 'PU_DO_DIA',
        headerName: 'PU Atualizado',
        sortable: false,
        filterable: false,
        valueGetter: (params: GridValueGetterParams) => {
          const pagamento = params.row as PagamentoResponse;
          return [PagamentoStatus.Concluida, PagamentoStatus.Cancelada].includes(pagamento.status)
            ? ''
            : pagamento.puDiario != null && pagamento.puDiario !== 0
              ? formatEightDecimalsCurrency(pagamento.puDiario)
              : '';
        },
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'MULTA',
        headerName: 'PU Multa',
        filterOperators,
        valueGetter: (params: GridValueGetterParams) => {
          const pagamento = params.row as PagamentoResponse;
          return pagamento.puMulta != null && pagamento.puMulta !== 0 ? formatEightDecimalsCurrency(pagamento.puMulta) : '';
        },
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'MORA',
        headerName: 'PU Mora',
        filterOperators,
        valueGetter: (params: GridValueGetterParams) => {
          const pagamento = params.row as PagamentoResponse;
          return pagamento.puMora != null && pagamento.puMora !== 0 ? formatEightDecimalsCurrency(pagamento.puMora) : '';
        },
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'DATA_VENCIMENTO',
        headerName: 'Vencimento',
        type: 'date',
        filterOperators: filterOperatorsData,
        valueGetter: (params: GridValueGetterParams) => formatDate((params.row as PagamentoResponse).dataVencimento),
        renderCell: (params: GridCellParams) => {
          const pagamento = params.row as PagamentoResponse;
          return (
            <>
              <Typography variant="body2">{formatDate(pagamento.dataVencimento)}</Typography>
            </>
          );
        },
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'DATA_LIQUIDACAO',
        headerName: 'Data Liquidação',
        type: 'date',
        filterOperators: filterOperatorsData,
        valueGetter: (params: GridValueGetterParams) => formatDate((params.row as PagamentoResponse).dataPagamento),
        renderCell: (params: GridCellParams) => {
          const pagamento = params.row as PagamentoResponse;
          return (
            <>
              <Typography variant="body2">{formatDate(pagamento.dataPagamento)}</Typography>
            </>
          );
        },
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
      {
        field: 'HAS_DOCUMENTS',
        headerName: 'Documento',
        filterable: false,
        sortable: false,
        disableExport: true,
        width: 80,
        minWidth: 100,
        maxWidth: 150,
        renderCell: (params: GridCellParams) => {
          const pagamento = params.row as PagamentoResponse;
          return (
            <Tooltip title={pagamento.hasDocuments ? 'Possui documento' : 'Sem documento'}>
              <span style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <span style={{
                  display: 'inline-block',
                  width: 16,
                  height: 16,
                  borderRadius: '50%',
                  backgroundColor: pagamento.hasDocuments ? '#4caf50' : '#d1c4e9',
                }} />
              </span>
            </Tooltip>
          );
        },
      },
      {
        field: 'actions',
        headerName: ' ',
        filterable: false,
        sortable: false,
        disableExport: true,
        renderCell: (params: GridCellParams) => (
          <MoreOptionsMenu>
            {(isUsuarioOperacoes || (isParticipanteCustodiante && (params.row as PagamentoResponse).liquidacaoAutomaticaBanco))
              && (params.row as PagamentoResponse).status === PagamentoStatus.Concluida && (
                <MenuItem onClick={() => handleOpenContestarPagamentoDrawer(params.row as PagamentoResponse)}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Contestar Liquidação'}
                </MenuItem>
              )}

            {(isUsuarioOperacoes || isUsuarioCadastroOperacoes) &&
              !isUsuarioLeitura &&
              (params.row as PagamentoResponse).status === PagamentoStatus.PendenteAprovacao && ([
                <MenuItem key="aprovar" onClick={() => handleOpenValidarLiquidacaoDrawer(params.row as PagamentoResponse)}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Aprovar'}
                </MenuItem>,
                <MenuItem key="reprovar" onClick={() => handleOpenValidarLiquidacaoDrawer(params.row as PagamentoResponse, true)}>
                  <Cancel fontSize="small" style={{ marginRight: '10px' }} />
                  {'Reprovar'}
                </MenuItem>
              ])}
            {podeSolicitarLiquidacao(usuarioLogado, params.row as PagamentoResponse) && (
                <MenuItem
                  onClick={() => {
                    const pagamento = params.row as PagamentoResponse;
                    if (deveReenviarSolicitacao(pagamento)) {
                      setPagamentoParaReenvio(pagamento);
                      setOpenEventoExtraordinarioDrawer(true);
                    } else {
                      handleOpenSolicitarLiquidacaoDrawer(pagamento);
                    }
                  }}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Solicitar Liquidação'}
                </MenuItem>
              )}
            {podeCancelarSolicitacaoEvento(usuarioLogado, params.row as PagamentoResponse) && (
                <MenuItem
                  key="cancelar-solicitacao"
                  onClick={() => handleCancelarSolicitacaoEvento(params.row as PagamentoResponse)}>
                  <Cancel fontSize="small" style={{ marginRight: '10px' }} />
                  {'Cancelar Solicitação'}
                </MenuItem>
              )}
            {!isUsuarioLeitura &&
              (isParticipanteEmissor || isUsuarioOperacoes || isUsuarioCadastroOperacoes) &&
              ([PagamentoStatus.Previsto, PagamentoStatus.ReprovadoAgenteFiduciario].includes(
                (params.row as PagamentoResponse).status)
              ) &&
              (params.row as PagamentoResponse).tipoLiquidacaoInstrumento &&
              (params.row as PagamentoResponse).tipoLiquidacaoInstrumento !== TipoLiquidacao.Direta && (
                <MenuItem
                  onClick={() => handleOpenSolicitarLiquidacaoBrutaEmissorDrawer(params.row as PagamentoResponse)}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Solicitar Liquidação'}
                </MenuItem>
              )}
            {!isUsuarioLeitura &&
              isParticipanteAgenteFiduciario &&
              (params.row as PagamentoResponse).status === PagamentoStatus.PendenteAprovacaoAgenteFiduciario &&
              (params.row as PagamentoResponse).tipoLiquidacaoInstrumento &&
              (params.row as PagamentoResponse).tipoLiquidacaoInstrumento !== TipoLiquidacao.Direta && (
                <MenuItem
                  onClick={() => handleOpenSolicitarLiquidacaoBrutaAFDrawer(params.row as PagamentoResponse)}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Solicitar Liquidação'}
                </MenuItem>
              )}
            {isUsuarioOperacoes &&
              !isUsuarioLeitura &&
              (params.row as PagamentoResponse).status === PagamentoStatus.AguardandoLiquidacao &&
              (params.row as PagamentoResponse).liquidacaoDireta && ([
                <MenuItem key="confirmar" onClick={() => handleOpenConfirmarLiquidacaoDrawer(params.row as PagamentoResponse)}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Confirmar Liquidação'}
                </MenuItem>,
                <MenuItem key="cancelar" onClick={() => handleOpenConfirmarLiquidacaoDrawer(params.row as PagamentoResponse, true)}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Cancelar Liquidação'}
                </MenuItem>
              ])}
            {!isUsuarioLeitura &&
              (isUsuarioOperacoes ||
                isUsuarioCadastroOperacoes) &&
              (params.row as PagamentoResponse).status === PagamentoStatus.AguardandoComprovante && ([
                <MenuItem key="anexar" onClick={() => handleOpenSolicitarLiquidacaoDrawer(params.row as PagamentoResponse)}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Anexar Comprovante'}
                </MenuItem>,
                isUsuarioOperacoes && (
                  <MenuItem key="reprovar-comprovante" onClick={() => handleOpenValidarLiquidacaoDrawer(params.row as PagamentoResponse, true)}>
                    <Cancel fontSize="small" style={{ marginRight: '10px' }} />
                    {'Reprovar'}
                  </MenuItem>
                )
              ])}
            {!isUsuarioLeitura && !(params.row as PagamentoResponse).isMultiCustodiante && (
              <MenuItem onClick={() => handleOpenAnexarComprovanteDrawer(params.row as PagamentoResponse)}>
                <AttachFile fontSize="small" style={{ marginRight: '10px' }} />
                {'Gestão de Comprovantes'}
              </MenuItem>
            )}
            {(isParticipanteEmissor || isParticipanteAgenteFiduciario || isUsuarioOperacoes) &&
              (params.row as PagamentoResponse).historicoPUsProjetados &&
              (params.row as PagamentoResponse).historicoPUsProjetados!.length > 0 && (
                <MenuItem onClick={() => handleOpenHistoricoPUsDrawer(params.row as PagamentoResponse)}>
                  <History fontSize="small" style={{ marginRight: '10px' }} />
                  {'Histórico de PUs'}
                </MenuItem>
              )}
          </MoreOptionsMenu>
        ),
        width: 150,
        minWidth: 150,
        maxWidth: 200,
      },
    ],
    [filterCodigoIF, filterInvestidor, filterDataFrom, filterDataTo, filterInadimplente]
  );

  const handleLiquidacaoEmLote = () => {
    setShowLiquidacaoEmLote(false);
    setLiquidacaoConfirmada(true);
    setSelectedPagamentos([]);
    setLiquidacaoEmLoteItens([]);

    setRefresh([]);
  };

  const handleClearFilters = useCallback(() => {
    setFilterDataFrom('');
    setFilterDataTo('');
    setFilterCodigoIF('');
    setFilterInvestidor('');
    setFilterInadimplente(undefined);

    setIsInadimplente(undefined);
    setApiDataFrom(undefined);
    setApiDataTo(undefined);

    setPage(0);
    setPageSize(20);

    if (dataGridApiRef.current) {
      dataGridApiRef.current.setFilterModel({ items: [], linkOperator: 'and' });
      dataGridApiRef.current.setSortModel([]);
    }

    setTopFilters([]);
    setTableFilters([]);

    setEventosFinanceirosFilter([]);
  }, [dataGridApiRef]);


  const handleSearch = (event?: React.MouseEvent<HTMLButtonElement>) => {
    if (event) {
      event.preventDefault();
    }

    const filters = new Array<EventosFinanceirosFilter>();

    let dataFrom: string | undefined;
    let dataTo: string | undefined;

    if (filterCodigoIF) {
      const codigo = filterCodigoIF.toUpperCase().trim();
      filters.push({
        columnType: 'CODIGO',
        operationFilterType: 'CONTAINS',
        value: codigo
      });
    }

    if (filterInvestidor) {
      const investidor = filterInvestidor.trim();
      filters.push({
        columnType: 'CPF_CNPJ_INVESTIDOR',
        operationFilterType: 'CONTAINS',
        value: stripCpfCnpjFormatting(investidor)
      });
    }

    if (filterDataFrom) {
      const dateParts = filterDataFrom.split('-');
      const apiDate = new Date(`${dateParts[0]}-${dateParts[1]}-${dateParts[2]}T00:00:00.000Z`);
      setApiDataFrom(apiDate);
    } else {
      setApiDataFrom(undefined);
    }

    if (filterDataTo) {
      const dateParts = filterDataTo.split('-');
      const apiDate = new Date(`${dateParts[0]}-${dateParts[1]}-${dateParts[2]}T00:00:00.000Z`);
      setApiDataTo(apiDate);

      const formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
      filters.push({
        columnType: 'DATA_VENCIMENTO',
        operationFilterType: 'CONTAINS',
        value: formattedDate,
        orderByType: 'ASC'
      });
    } else {
      setApiDataTo(undefined);
    }

    setIsInadimplente(filterInadimplente);

    setLinkOperator('AND');
    setTopFilters(filters);
    setEventosFinanceirosFilter([...filters, ...tableFilters]);
    setPage(0);
  };

  return (
    <>
      {pagamentoSolicitado && (
        <>
          <GenericToast kind={GenericToastKind.Warning} onDismiss={() => setPagamentoSolicitado(false)}>
            <Typography variant="body2" display={'inline'}>
              {'Solicitação de liquidação enviada. Aguardando liquidação.'}
            </Typography>
          </GenericToast>
          <MdSpace />
        </>
      )}
      {pagamentoRejeitado && (
        <>
          <GenericToast kind={GenericToastKind.Error} onDismiss={() => setPagamentoRejeitado(false)}>
            <Typography variant="body2" display={'inline'}>
              {'Solicitação de liquidação reprovada com sucesso.'}
            </Typography>
          </GenericToast>
          <MdSpace />
        </>
      )}
      {liquidacaoConfirmada && (
        <>
          <GenericToast kind={rejectPagamento ? GenericToastKind.Error : GenericToastKind.Success} onDismiss={() => setLiquidacaoConfirmada(false)}>
            <Typography variant="body2" display={'inline'}>
              {`Liquidação ${rejectPagamento ? 'cancelada' : contestarPagamento ? 'contestada' : 'confirmada'} com sucesso!`}
            </Typography>
          </GenericToast>
          <MdSpace />
        </>
      )}
      {codigoPagamentoLiquidado && (
        <>
          <GenericToast kind={GenericToastKind.Success} onDismiss={() => setCodigoPagamentoLiquidado(undefined)}>
            <Typography variant="body2" display={'inline'}>
              {'Instrumento financeiro'}
            </Typography>
            &nbsp;<Typography display={'inline'}>{codigoPagamentoLiquidado}</Typography>&nbsp;
            <Typography variant="body2" display={'inline'}>
              {'liquidado com sucesso.'}
            </Typography>
          </GenericToast>
          <MdSpace />
        </>
      )}
      {codigoPagamentoAguardandoLiquidacao && (
        <>
          <GenericToast kind={GenericToastKind.Warning} onDismiss={() => setCodigoPagamentoAguardandoLiquidacao(undefined)}>
            <Typography variant="body2" display={'inline'}>
              {'Instrumento financeiro'}
            </Typography>
            &nbsp;<Typography display={'inline'}>{codigoPagamentoAguardandoLiquidacao}</Typography>&nbsp;
            <Typography variant="body2" display={'inline'}>
              {' aguardando a confirmação da liquidação.'}
            </Typography>
          </GenericToast>
          <MdSpace />
        </>
      )}

      {!showLiquidacaoEmLote && (
        <>
          <Grid container justifyContent="space-between" alignItems="flex-start">
            {podeCadastrarEventoExtraordinario(usuarioLogado) && (
                <Grid item>
                  <Button
                    startIcon={<AddCircleIcon fontSize={'small'} />}
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => setOpenEventoExtraordinarioDrawer(true)}
                  >
                    {'Evento Extraordinário'}
                  </Button>
                  <MdSpace />
                </Grid>
              )
            }

            <Grid item style={{ marginLeft: 'auto' }}>
              {!isUsuarioLeitura &&
                (isUsuarioOperacoes ||
                  isUsuarioCadastroOperacoes ||
                  isParticipanteEmissor ||
                  isParticipanteCustodiante ||
                  isParticipanteEscriturador ||
                  isParticipanteAgenteFiduciario) && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleOpenLiquidacaoEmLoteModal}
                    >
                      {'Liquidar em Lote'}
                    </Button>
                )
              }
            </Grid>
          </Grid>

          <Grid container alignItems="center" style={{ marginBottom: '16px' }}>
            <Grid container item xs={12}>
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <Typography>{'Vencimento DE'}</Typography>
                  <FormControl fullWidth>
                    <TextField
                      type="date"
                      value={filterDataFrom}
                      onChange={(value) => {
                        setFilterDataFrom(value);

                        if (filterDataTo && filterDataTo < value) {
                          setFilterDataTo(value);
                        }
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <Typography>{'Vencimento ATÉ'}</Typography>
                  <FormControl fullWidth>
                    <TextField
                      type="date"
                      value={filterDataTo}
                      onChange={(value) => setFilterDataTo(value)}
                      inputProps={{ min: filterDataFrom || undefined }}
                    />
                  </FormControl>
                </Grid>
                <Grid item>
                  <Typography>{'Código IF'}</Typography>
                  <TextField
                    value={filterCodigoIF}
                    onChange={(value) => setFilterCodigoIF(value)}
                    placeholder="Digite o código IF"
                  />
                </Grid>
                <Grid item>
                  <Typography>{'Investidor'}</Typography>
                  <TextField
                    placeholder="CPF/CNPJ do Investidor"
                    value={CpfCnpjMask(filterInvestidor ?? '')}
                    onChange={(value) => setFilterInvestidor(value)}
                  />
                </Grid>
                <Grid item style={{ minWidth: '160px' }}>
                  <Typography>{'Adimplência'}</Typography>
                  <Dropdown
                    options={[
                      { description: 'Todas', value: 'todas' },
                      { description: 'Inadimplente', value: 'inadimplente' },
                      { description: 'Adimplente', value: 'adimplente' }
                    ]}
                    value={filterInadimplente == undefined ? 'todas' : filterInadimplente === true ? 'inadimplente' : 'adimplente'}
                    onChange={(value) => setFilterInadimplente(value === 'inadimplente' ? true : value === 'adimplente' ? false : undefined)}
                  />
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => handleSearch(e)}
                    type="button"
                    style={{ marginRight: '8px' }}
                  >
                    {'Pesquisar'}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={handleClearFilters}
                    type="button"
                  >
                    {'Limpar Filtros'}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <LegendaStatusEventos />
          <MdSpace />

          <DataGridPro
            apiRef={dataGridApiRef}
            autoHeight
            localeText={localizedTextsMap}
            componentsProps={componentsPropsValues}
            rows={pagamentosPaginated}
            rowCount={pageCount}
            columns={getGridColumns()}
            components={{
              Toolbar: () => (
                <DataGridToolbar
                  filter={eventosFinanceirosFilter}
                  inadimplente={isInadimplente}
                  dataFrom={apiDataFrom}
                  dataTo={apiDataTo}
                  linkOperator={linkOperator}
                />
              ),
            }}
            disableSelectionOnClick
            rowsPerPageOptions={rowsPerPageOptionsValues}
            onPageChange={(newPage) => setPage(newPage)}
            pagination
            paginationMode="server"
            onPageSizeChange={(newPageSize) => {
              setPageSize(newPageSize), setPage(0);
            }}
            pageSize={pageSize}
            filterMode="server"
            onFilterModelChange={onFilterChange}
            sortingMode="server"
            onSortModelChange={onSortChange}
            getDetailPanelHeight={() => 'auto'}
            getDetailPanelContent={(params) => {
              const pagamento = params.row as PagamentoResponse;
              return (
                <InvestidoresPrivadosDetail
                  investidores={pagamento.instrumentoFinanceiro?.investidoresPrivados}
                />
              );
            }}
            detailPanelExpandedRowIds={expandedDetailPanels}
            onDetailPanelExpandedRowIdsChange={(newIds) => setExpandedDetailPanels(newIds)}
          />
          <XlSpace />
        </>
      )}

      {SolicitarLiquidacaoDrawer}
      <ValidarLiquidacaoDrawer
        pagamento={selectedPagamento}
        opened={openValidarLiquidacaoDrawer}
        onClose={() => setOpenValidarLiquidacaoDrawer(false)}
        reject={rejectPagamento}
        onSubmitSuccess={handleSubmitValidarLiquidacaoSuccess}
      />
      <ConfirmarLiquidacaoDrawer
        pagamentoProps={selectedPagamento}
        pagamentoDocuments={pagamentoDocuments}
        opened={openConfirmarLiquidacaoDrawer}
        onClose={handleCloseConfirmarLiquidacaoDrawer}
        reject={rejectPagamento}
        contestar={contestarPagamento}
        onSubmitSuccess={handleSubmitConfirmarLiquidacaoSuccess}
      />
      <EventoExtraordinarioDrawer
        opened={openEventoExtraordinarioDrawer}
        onClose={() => { setOpenEventoExtraordinarioDrawer(false); setPagamentoParaReenvio(undefined); }}
        onSubmitSuccess={handleSubmitEventoExtraordinarioSuccess}
        pagamentoParaReenvio={pagamentoParaReenvio}
      />
      <AnexarComprovanteDrawer
        pagamento={selectedPagamento}
        pagamentoDocuments={pagamentoDocuments}
        opened={openAnexarComprovanteDrawer}
        onClose={handleCloseAnexarComprovanteDrawer}
        onUploadSuccess={handleAnexarComprovanteSuccess}
      />
      <RevisarPagamentoAgenteFiduciarioDrawer
        pagamento={selectedPagamento}
        pagamentoDocuments={pagamentoDocuments}
        opened={openRevisarAgenteFiduciarioDrawer}
        onClose={handleCloseRevisarAgenteFiduciarioDrawer}
        onSubmitSuccess={() => {
          setCodigoPagamentoLiquidado(selectedPagamento?.instrumentoFinanceiro.codigo);
          setRefresh([]);
        }}
      />
      <SolicitarLiquidacaoBrutaEmissorDrawer
        pagamento={selectedPagamento}
        opened={openSolicitarLiquidacaoBrutaEmissorDrawer}
        onClose={handleCloseSolicitarLiquidacaoBrutaEmissorDrawer}
        onSubmitSuccess={() => {
          handleCloseSolicitarLiquidacaoBrutaEmissorDrawer();
          setRefresh([]);
        }}
      />
      <SolicitarLiquidacaoBrutaAgenteFiduciarioDrawer
        pagamento={selectedPagamento}
        opened={openSolicitarLiquidacaoBrutaAFDrawer}
        onClose={handleCloseSolicitarLiquidacaoBrutaAFDrawer}
        onSubmitSuccess={() => {
          handleCloseSolicitarLiquidacaoBrutaAFDrawer();
          setRefresh([]);
        }}
        onReprovar={() => {
          handleCloseSolicitarLiquidacaoBrutaAFDrawer();
          setRefresh([]);
        }}
      />
      <HistoricoPUsModal
        pagamento={selectedPagamento}
        opened={openHistoricoPUsDrawer}
        onClose={handleCloseHistoricoPUsDrawer}
      />
      <Dialog open={openLiquidacaoEmLoteModal} onClose={handleCloseLiquidacaoEmLoteModal} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h5">Liquidar em lote</Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" style={{ marginBottom: '8px' }}>
                {'Baixe o arquivo modelo, preencha com os dados dos eventos e faça o upload para processar a liquidação em lote.'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                startIcon={<GetApp />}
                variant="outlined"
                color="primary"
                onClick={handleDownloadModeloLiquidacaoEmLote}
              >
                {'Baixar planilha modelo'}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" style={{ marginBottom: '8px', marginTop: '8px' }}>
                {'Upload do arquivo preenchido:'}
              </Typography>
              <UploadDocs
                onChange={(attachments) => setLiquidacaoEmLoteFile(attachments)}
                overrideAcceptableFileTypes={[AcceptableFileTypes.AppExcel, AcceptableFileTypes.AppExcelGeneric]}
                multipleFiles={false}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px' }}>
          <Button
            variant="outlined"
            onClick={handleCloseLiquidacaoEmLoteModal}
            disabled={isProcessingUpload}
          >
            {'Cancelar'}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLiquidarEmLoteUpload}
            disabled={liquidacaoEmLoteFile.length === 0 || isProcessingUpload}
          >
            {isProcessingUpload ? 'Processando...' : 'Liquidar'}
          </Button>
        </DialogActions>
      </Dialog>
      {showLiquidacaoEmLote && (
        <LiquidacaoEmLote
          itens={liquidacaoEmLoteItens}
          onCancel={(wasProcessed) => {
            setShowLiquidacaoEmLote(false);

            if (wasProcessed) {
              setSelectedPagamentos([]);
              setLiquidacaoEmLoteItens([]);
              handleSearch();
            }
          }}
          postSolicitarAprovarConfirmarLiquidacaoEmLote={postSolicitarAprovarConfirmarLiquidacaoEmLote}
          postDocumentosLiquidacao={POSTDocumentosLiquidacao}
        />
      )}
      {consultaFeedback && (
        <FeedbackLoteModal
          open={!!consultaFeedback}
          onClose={() => setConsultaFeedback(null)}
          data={consultaFeedback}
          tituloFalha="Itens com falha"
        />
      )}
    </>
  );
};

export default EventosFinanceiros;